module.exports = "/assets/data/0259cc3684d535e01c06c2db91e7a186-WF12.data.json";